import { AppBroadcast } from '@aipb/env/model';
import { FrameRepository, FrameService, MOBILE_MEDIA_QUERY } from '@aipb/frame/data-access';
import { PersonalContentPluginComponent } from '@aipb/personal-content/plugin';
import { InsideLoadingComponent } from '@aipb/ui/loading';
import { CONFIG_APPLICATIONS } from '@aipb/util/di';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppBroadcastComponent } from '../../../app-broadcast/app-broadcast.component';
import { BroadcastMessageComponent } from '../../../feature-broadcast-message';
import { SidebarComponent } from '../../../feature-sidebar';
import { ToolbarComponent } from '../../../feature-toolbar/containers/toolbar/toolbar.component';

@Component({
  selector: 'fr-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss'],
  imports: [
    CommonModule,
    ToolbarComponent,
    MatSidenavModule,
    SidebarComponent,
    PersonalContentPluginComponent,
    BroadcastMessageComponent,
    InsideLoadingComponent,
    AppBroadcastComponent
  ]
})
export class FrameComponent implements OnInit {
  frameRepository = inject(FrameRepository);
  transloco = inject(TranslocoService);
  frameService = inject(FrameService);
  bpo = inject(BreakpointObserver);
  cdr = inject(ChangeDetectorRef);
  loading$ = this.frameRepository.loading$;
  forceFullHeight$ = this.frameRepository.forceFullHeight$;
  activeApp$ = this.frameRepository.activeApp$;
  isMobile$ = this.frameRepository.isMobile$;
  sidebarExpanded$ = this.frameRepository.sidebarExpanded$;
  private applications = inject(CONFIG_APPLICATIONS);
  // @ts-expect-error foo
  appBroadcast$: Observable<AppBroadcast> = this.frameRepository.activeApplication$.pipe(
    map((activeApp) => {
      if (!activeApp) return undefined;

      if (activeApp.id in this.applications) {
        return this.applications?.[activeApp.id]?.[activeApp.configId]?.broadcast;
      }

      return undefined;
    })
  );

  get currentLang(): string {
    return this.transloco.getActiveLang();
  }

  ngOnInit(): void {
    this.bpo.observe(MOBILE_MEDIA_QUERY).subscribe((state) => {
      this.frameService.setIsMobile(state.matches);

      if (state.matches) {
        this.frameService.setSidebarExpanded(false);
      }

      this.cdr.detectChanges();
    });
  }
}
